// extracted by mini-css-extract-plugin
module.exports = {"home-page":"components-HomePage-HomePage__home-page--WL42z"};